import { put, takeEvery, all, takeLatest, select } from 'redux-saga/effects';
import { userSignInMS, userSignIn, userLogOut, getUserToken, getUserByToken, getWallsAPI, getWallAPI, updateWallAPI, removeWallAPI, addWallAPI, removePostAPI, updatePostAPI, addPostAPI, getPostAPI, getPostsAPI, removeCommentAPI, updateCommentAPI, addCommentAPI, getCommentAPI, getCommentsAPI, likeHandlerAPI, likeCountHandlerAPI, updatePostFeaturedAPI, updatePostFeaturedOrderAPI, addTagAPI, updateTagAPI, 
    removeTagAPI, getTagAPI, getTagsAPI, getAlertsAPI, getAlertAPI, addAlertAPI, updateAlertAPI, removeAlertAPI, checkPendingPostsAPI, getUsersAPI,
    addUserAPI,
    updateUserAPI,
    removeUserAPI, 
    authorizeUserAPI,
    deauthorizeUserAPI,
    getKeysAPI,
    addKeyAPI,
    udpateKeyAPI,
    removeKeyAPI,
    getWallsAPIAdmin,
    getEventsAPI,
    getEventAPI,
    addEventAPI,
    updateEventAPI,
    removeEventAPI
} from '../helpers/api';
import {
    SIGNIN, MSSIGNIN, LOGOUT, TOKEN_REQUEST, signInSuccess, signInError, logOutSuccess, logOutError, tokenSuccess, tokenError, setToken, setUser, AUTH_STATUS, REQUEST_WALLS, REQUEST_WALL, ADD_WALL, UPDATE_WALL, REMOVE_WALL, REQUEST_POSTS, REQUEST_POST, ADD_POST, UPDATE_POST, REMOVE_POST, REQUEST_COMMENTS, REQUEST_COMMENT, ADD_COMMENT, UPDATE_COMMENT, REMOVE_COMMENT, getWallsSuccess, getWallsError, getWallSuccess, getWallError, updateWallSuccess, updateWallError, removeWallSuccess, removeWallError, addWallSuccess, addWallError, removePostError, removePostSuccess, updatePostError, updatePostSuccess, addPostError, addPostSuccess, getPostError, getPostSuccess, getPostsError, getPostsSuccess, removeCommentError, removeCommentSuccess, updateCommentError, updateCommentSuccess, addCommentError, addCommentSuccess, getCommentError, getCommentSuccess, getCommentsError, getCommentsSuccess, likeSuccess, likeError, UPDATE_LIKE, likeCountUpdateSuccess, likeCountUpdateError, UPDATE_LIKE_COUNT, UPDATE_FEATUREDPOST, updateFeaturedPostSuccess, updateFeaturedPostError, updateFeaturedPostOrderSuccess, updateFeaturedPostOrderError,
    UPDATE_FEATURED_ORDER,
    REQUEST_TAGS,
    ADD_TAG,
    UPDATE_TAG,
    REMOVE_TAG,
    REQUEST_TAG,
    addTagSuccess,
    addTagError,
    getTagSuccess,
    getTagError,
    updateTagSuccess,
    updateTagError,
    removeTagSuccess,
    removeTagError,
    getTagsSuccess,
    getTagsError,
    REQUEST_ALERTS,
    ADD_ALERT,
    UPDATE_ALERT,
    REMOVE_ALERT,
    REQUEST_ALERT,
    alertAddSuccess,
    alertAddError,
    getAlertSuccess,
    getAlertError,
    alertUpdateSuccess,
    alertUpdateError,
    alertRemoveSuccess,
    alertRemoveError,
    getAlertsSuccess,
    getAlertsError,
    CHECK_PENDING_POSTS,
    updatePendingPostsError,
    updatePendingPostsSuccess,
    REQUEST_USERS,
    setUsersSuccess,
    setUsersError,
    ADD_USER,
    UPDATE_USER,
    REMOVE_USER,
    addUserSuccess,
    addUserError,
    updateUserSuccess,
    updateUserError,
    removeUserSuccess,
    removeUserError,
    AUTHORIZE_USER,
    authorizeUserSuccess,
    authorizeUserError,
    deauthorizeUserSuccess,
    deauthorizeUserError,
    DEAUTHORIZE_USER,
    REQUEST_KEYS,
    ADD_KEY,
    UPDATE_KEY,
    REMOVE_KEY,
    getKeysSuccess,
    getKeysError,
    addKeySuccess,
    addKeyError,
    updateKeySuccess,
    updateKeyError,
    removeKeySuccess,
    removeKeyError,
    REQUEST_WALLS_ADMIN
} from '../handlers.actions';
import { setCookie, deleteCookie, getCookie } from '../helpers/cookies';
import { AnyAction } from 'redux';
import { ADD_EVENT, eventAddError, eventAddSuccess, eventRemoveError, eventRemoveSuccess, eventUpdateError, eventUpdateSuccess, getEventError, getEventsError, getEventsSuccess, getEventSuccess, REMOVE_EVENT, REQUEST_EVENT, REQUEST_EVENTS, UPDATE_EVENT } from '../handlers.actions/edu.events';

const APP_SESSION_COOKIE = 'pancan_wall_admin';

/** ACTION INTERFACE */
export interface IAction {
    type: any;
    payload: any;
}
export interface ResponseGenerator {
    config?: any,
    data?: any,
    headers?: any,
    request?: any,
    status?: number,
    statusText?: string,
    success?: boolean,
    user?: any,
    id?: any,
    singinType?: any
}


function* eventWatcher() {
    yield takeLatest(SIGNIN, logInUser);
    yield takeLatest(MSSIGNIN, verifyUser);
    yield takeLatest(LOGOUT, logOutUser);
    yield takeEvery(TOKEN_REQUEST, tokenVerify);
    yield takeEvery(AUTH_STATUS, statusChecker);
    yield takeLatest(REQUEST_USERS, getUsers);

    /** Users */
    yield takeLatest(ADD_USER, addUser);
    yield takeLatest(UPDATE_USER, updateUser);
    yield takeLatest(REMOVE_USER, removeUser);
    yield takeLatest(AUTHORIZE_USER, authorizeUser);
    yield takeEvery(DEAUTHORIZE_USER, deauthorizeUser);

    /** Walls */
    yield takeEvery(REQUEST_WALLS, getWalls);
    yield takeEvery(REQUEST_WALLS_ADMIN, getWallsAdmin);
    yield takeEvery(REQUEST_WALL, getWall);
    yield takeEvery(ADD_WALL, addWall);
    yield takeEvery(UPDATE_WALL, updateWall);
    yield takeEvery(REMOVE_WALL, removeWall);

    /** Posts */
    yield takeEvery(REQUEST_POSTS, getPosts);
    yield takeEvery(REQUEST_POST, getPost);
    yield takeEvery(ADD_POST, addPost);
    yield takeEvery(UPDATE_POST, updatePost);
    yield takeEvery(REMOVE_POST, removePost);
    yield takeEvery(UPDATE_FEATUREDPOST, updatePostFeatured);
    /** Comments */
    yield takeEvery(REQUEST_COMMENTS, getComments);
    yield takeEvery(REQUEST_COMMENT, getComment);
    yield takeEvery(ADD_COMMENT, addComment);
    yield takeEvery(UPDATE_COMMENT, updateComment);
    yield takeEvery(REMOVE_COMMENT, removeComment);
    /** Likes */
    yield takeEvery(UPDATE_LIKE, likeHandler);
    yield takeEvery(UPDATE_LIKE_COUNT, likeCountHandler);
    /** Update featured position */
    yield takeLatest(UPDATE_FEATURED_ORDER, updateFeaturedOrderHandler);
    /** Tags */
    yield takeEvery(REQUEST_TAGS, getTags);
    yield takeEvery(REQUEST_TAG, getTag);
    yield takeEvery(ADD_TAG, addTag);
    yield takeEvery(UPDATE_TAG, updateTag);
    yield takeEvery(REMOVE_TAG, removeTag);
    /** Alerts */
    yield takeEvery(REQUEST_ALERTS, getAlerts);
    yield takeEvery(REQUEST_ALERT, getAlert);
    yield takeEvery(ADD_ALERT, addAlert);
    yield takeEvery(UPDATE_ALERT, updateAlert);
    yield takeEvery(REMOVE_ALERT, removeAlert);
    /** Pending Posts */
    yield takeLatest(CHECK_PENDING_POSTS, pendingPosts);

    /** Keys */
    yield takeLatest(REQUEST_KEYS, getKeys);
    yield takeLatest(ADD_KEY, addKey);
    yield takeLatest(UPDATE_KEY, updateKey);
    yield takeLatest(REMOVE_KEY, removeKey);

    /** Educational Events */
    yield takeLatest(REQUEST_EVENTS, getEvents);
    yield takeLatest(REQUEST_EVENT, getEvent);
    yield takeLatest(ADD_EVENT, addEvent);
    yield takeLatest(UPDATE_EVENT, updateEvent);
    yield takeLatest(REMOVE_EVENT, removeEvent);

}

/** USER FUNCTIONS */
function* verifyUser(action: IAction) {
    const response: ResponseGenerator = yield userSignInMS(action.payload);
    const handler: any = response.success ? signInSuccess(response.data) : signInError();
    if (response.success) {
        setCookie(APP_SESSION_COOKIE, response.data.token, 2); // 2 hrs
    }
    yield put(handler);
}

function* logInUser(action: IAction) {
    const response: ResponseGenerator = yield userSignIn(action.payload);
    const handler: any = response.success
        ? signInSuccess(response.data)
        : signInError();
    if (response.success) {
        setCookie(APP_SESSION_COOKIE, response.data.token, 2); // 2 hrs
    }
    yield put(handler);
}

function* logOutUser() {
    const user: ResponseGenerator = yield select((state: any) => state.rootReducer.user);
    const singinType = user.singinType;
    if (user) {
        const response: ResponseGenerator = yield userLogOut(user.id);
        const handler: any = response.success ? logOutSuccess() : logOutError();
        deleteCookie(APP_SESSION_COOKIE, singinType);
        yield put(handler);
        return;
    }
    deleteCookie(APP_SESSION_COOKIE, singinType);
    yield put(logOutSuccess());

}

function* tokenVerify(action: IAction) {
    const response: ResponseGenerator = yield getUserToken(action.payload.id);
    const handler: any = response.success
        ? tokenSuccess(response.data.id)
        : tokenError();
    yield put(handler);
}

function* statusChecker() {
    const token: string = yield getCookie(APP_SESSION_COOKIE);
    if (token) {
        const response: ResponseGenerator = yield getUserByToken(token);
        yield put(setToken(token));
        yield put(setUser(response.data));
        return;
    }
    yield put(setToken(token));
}

function* getUsers() {
    /** from here, we could restric this call to admins only */
    // const user: ResponseGenerator = yield select((state: any) => state.rootReducer.user);
    const users: ResponseGenerator = yield getUsersAPI();
    const handler = (users.success) ? setUsersSuccess(users.data) : setUsersError();
    yield put(handler);
}

/** Users */
function* addUser(action:IAction){
    const {payload} = action;
    const response: ResponseGenerator = yield addUserAPI(payload);
    const handler:any = response.success ? addUserSuccess(response.data): addUserError();
    yield put(handler);
}

function* authorizeUser(action:IAction){
    const {payload} = action;
    const response: ResponseGenerator = yield authorizeUserAPI(payload);
    const handler:any = response.success ? authorizeUserSuccess(): authorizeUserError();
    yield put(handler);
}

function* deauthorizeUser(action:IAction){
    const {payload} = action;
    const response: ResponseGenerator = yield deauthorizeUserAPI(payload);
    const handler:any = response.success ? deauthorizeUserSuccess(response.data): deauthorizeUserError();
    yield put(handler);
}


function* updateUser(action:IAction){
    const {payload} = action;
    const response: ResponseGenerator = yield updateUserAPI(payload);
    const handler:any = response.success ? updateUserSuccess(response.data): updateUserError();
    yield put(handler);
}

function* removeUser(action:IAction){
    const {payload} = action;
    const response: ResponseGenerator = yield removeUserAPI(payload);
    const handler:any = response.success ? removeUserSuccess(response.data): removeUserError();
    yield put(handler);
}

/** WALL */
function* getWalls(action: IAction) {
    const response: ResponseGenerator = yield getWallsAPI(action.payload);
    const handler: any = response.success
        ? getWallsSuccess(response.data)
        : getWallsError();
    yield put(handler);
}

function* getWallsAdmin(action: IAction) {
    const response: ResponseGenerator = yield getWallsAPIAdmin();
    const handler: any = response.success
        ? getWallsSuccess(response.data)
        : getWallsError();
    yield put(handler);
}

function* getWall(action: IAction) {
    const response: ResponseGenerator = yield getWallAPI(action.payload);
    const handler: any = response.success
        ? getWallSuccess(response.data)
        : getWallError();
    yield put(handler);
}

function* addWall(action: IAction) {
    const response: ResponseGenerator = yield addWallAPI(action.payload);
    const handler: any = response.success
        ? addWallSuccess(response.data)
        : addWallError();
    yield put(handler);
}

function* updateWall(action: IAction) {
    const response: ResponseGenerator = yield updateWallAPI(action.payload);
    const handler: any = response.success
        ? updateWallSuccess(response.data)
        : updateWallError();
    yield put(handler);
}

function* removeWall(action: IAction) {
    const response: ResponseGenerator = yield removeWallAPI(action.payload);
    const handler: any = response.success
        ? removeWallSuccess(response.data)
        : removeWallError();
    yield put(handler);
}

/** POST */
function* getPosts(action: IAction) {
    const walls: AnyAction = yield select((state: any) => state.rootReducer.walls);
    const match:AnyAction  = yield select((state:any) => state.router);
    const id = match.location.pathname.replace('/wall/', '');    
    const wall = walls.find((wall:any) => id === wall._id);        
    const {featuredPosts} = wall || []; 
    const response: ResponseGenerator = yield getPostsAPI(action.payload);
    let handler;
    if(response.success){
        const posts = response.data;        
        if(featuredPosts && featuredPosts.length > 0){
            let featuredList = posts.filter((item:any) => featuredPosts.some((post:any) =>  {
                if(post.id === item._id){
                    item['pos'] = post.position;
                    return true;
                } else { return false;}
            }));
            
            featuredList = featuredList.sort((a:any, b:any) => a.pos - b.pos);

            // Create the final post list remove dups 
            const merged = [...featuredList, ...posts ];
            const set  = new Set();
            const finalList = merged.filter((post:any) => {
                if(!set.has(post._id)){
                    set.add(post._id);
                    return true;
                }
                return false;
            }, set);
            
            handler= getPostsSuccess(finalList);
        } else {
            handler = getPostsSuccess(posts);
        }
    } else {
        handler = getPostsError();
    }

    yield put(handler);
}


function* reorderPosts(){
    const walls: AnyAction = yield select((state: any) => state.rootReducer.walls);
    const match:AnyAction  = yield select((state:any) => state.router);
    const id = match.location.pathname.replace('/wall/', '');
    const wall = walls.find((wall:any) => id === wall._id);        
    const {feedTagsRef} = wall;    
    const tags = wall.feedTagsRef.length > 0 ? {tags: feedTagsRef, version: 2}: {tags: wall.feedTags, version: 1};
    
    /** Re order the list here */
    yield getPosts({type: 'REORDERING_POST_HELPER', payload: tags});
    
}

function* getPost(action: IAction) {
    const response: ResponseGenerator = yield getPostAPI(action.payload);
    const handler: any = response.success
        ? getPostSuccess(response.data)
        : getPostError();
    yield put(handler);
}


function* addPost(action: IAction) {
    const response: ResponseGenerator = yield addPostAPI(action.payload);
    const handler: any = response.success
        ? addPostSuccess(response.data)
        : addPostError();
    yield put(handler);
}

function* updatePost(action: IAction) {
    const response: ResponseGenerator = yield updatePostAPI(action.payload);
    const handler: any = response.success
        ? updatePostSuccess(response.data)
        : updatePostError();
    yield put(handler);
}

function* removePost(action: IAction) {
    const response: ResponseGenerator = yield removePostAPI(action.payload);
    const handler: any = response.success
        ? removePostSuccess(response.data)
        : removePostError();
    yield put(handler);
}

/** COMMENTS */
function* getComments(action: IAction) {
    const response: ResponseGenerator = yield getCommentsAPI(action.payload);
    const handler: any = response.success
        ? getCommentsSuccess(response.data)
        : getCommentsError();
    yield put(handler);
}

function* getComment(action: IAction) {
    const response: ResponseGenerator = yield getCommentAPI(action.payload);
    const handler: any = response.success
        ? getCommentSuccess(response.data)
        : getCommentError();
    yield put(handler);
}

function* addComment(action: IAction) {
    const response: ResponseGenerator = yield addCommentAPI(action.payload);
    const handler: any = response.success
        ? addCommentSuccess(response.data)
        : addCommentError();
    yield put(handler);
}

function* updateComment(action: IAction) {
    const response: ResponseGenerator = yield updateCommentAPI(action.payload);
    const handler: any = response.success
        ? updateCommentSuccess(response.data)
        : updateCommentError();
    yield put(handler);
}

function* removeComment(action: IAction) {
    const response: ResponseGenerator = yield removeCommentAPI(action.payload);
    const handler: any = response.success
        ? removeCommentSuccess(response.data)
        : removeCommentError();
    yield put(handler);
}

/** TAGS HANDLER */
function* getTags() {
    const response: ResponseGenerator = yield getTagsAPI();
    const handler: any = response.success ? getTagsSuccess(response.data) : getTagsError();
    yield put(handler);
}

function* getTag(action: IAction) {
    const response: ResponseGenerator = yield getTagAPI(action.payload);
    const handler: any = response.success ? getTagSuccess(response.data) : getTagError();
    yield put(handler);
}

function* addTag(action: IAction) {
    const response: ResponseGenerator = yield addTagAPI(action.payload);
    const handler: any = response.success ? addTagSuccess(response.data) : addTagError();
    yield put(handler);
}

function* updateTag(action: IAction) {
    const response: ResponseGenerator = yield updateTagAPI(action.payload);
    const handler: any = response.success ? updateTagSuccess(response.data) : updateTagError();
    yield put(handler);
}

function* removeTag(action: IAction) {
    const response: ResponseGenerator = yield removeTagAPI(action.payload);
    const handler: any = response.success ? removeTagSuccess(response.data) : removeTagError();
    yield put(handler);
}

/** ALERTS */
function* getAlerts() {
    const response: ResponseGenerator = yield getAlertsAPI();
    const handler: any = response.success ? getAlertsSuccess(response.data) : getAlertsError();
    yield put(handler);
}

function* getAlert(action: IAction) {
    const response: ResponseGenerator = yield getAlertAPI(action.payload);
    const handler: any = response.success ? getAlertSuccess(response.data) : getAlertError();
    yield put(handler);
}

function* addAlert(action: IAction) {
    const response: ResponseGenerator = yield addAlertAPI(action.payload);
    const handler: any = response.success ? alertAddSuccess(response.data) : alertAddError();
    yield put(handler);
}

function* updateAlert(action: IAction) {
    const response: ResponseGenerator = yield updateAlertAPI(action.payload);
    const handler: any = response.success ? alertUpdateSuccess(response.data) : alertUpdateError();
    yield put(handler);
}

function* removeAlert(action: IAction) {
    const response: ResponseGenerator = yield removeAlertAPI(action.payload);
    const handler: any = response.success ? alertRemoveSuccess(response.data) : alertRemoveError();
    yield put(handler);
}

/** LIKE HANDLER */
function* likeHandler(action: IAction) {
    const response: ResponseGenerator = yield likeHandlerAPI(action.payload);
    const handler: any = response.success ? likeSuccess(response.data) : likeError();
    yield put(handler);
}

function* likeCountHandler(action: IAction) {
    const response: ResponseGenerator = yield likeCountHandlerAPI(action.payload);
    const handler: any = response.success ? likeCountUpdateSuccess(response.data) : likeCountUpdateError();
    yield put(handler);
}

function* updatePostFeatured(action: IAction) {
    const response: ResponseGenerator = yield updatePostFeaturedAPI(action.payload);
    const handler: any = response.success ? updateFeaturedPostSuccess(response.data) : updateFeaturedPostError();
    yield put(handler);
    yield reorderPosts();
}

function* updateFeaturedOrderHandler(action: IAction) {
    const response: ResponseGenerator = yield updatePostFeaturedOrderAPI(action.payload);
    const handler: any = response.success ? updateFeaturedPostOrderSuccess(response.data) : updateFeaturedPostOrderError();
    yield put(handler);
    yield reorderPosts();
}


function* pendingPosts() {
    const response: ResponseGenerator = yield checkPendingPostsAPI();
    const handler: any = response.success ? updatePendingPostsSuccess(response.data) : updatePendingPostsError();
    yield put(handler);
}

/** Keys Methods */
function* getKeys(){
    const response:ResponseGenerator = yield getKeysAPI();
    const handler = response.success? getKeysSuccess(response.data): getKeysError();
    yield put(handler);
}

function* addKey(action:IAction){
    const user: ResponseGenerator = yield select((state: any) => state.rootReducer.user);
    const {payload} = action;
    const response:ResponseGenerator = yield addKeyAPI(payload, user.id);
    const handler = response.success? addKeySuccess(response.data): addKeyError();
    yield put(handler);
}

function* updateKey(action:IAction) {
    const {payload} = action;
    const response:ResponseGenerator = yield udpateKeyAPI(payload);
    const handler = response.success? updateKeySuccess(response.data): updateKeyError();
    yield put(handler);
}

function* removeKey(action:IAction){
    const {payload} = action;
    const response:ResponseGenerator = yield removeKeyAPI(payload);
    const handler = response.success? removeKeySuccess(response.data): removeKeyError();
    yield put(handler);
}


/** ALERTS */
function* getEvents() {
    const response: ResponseGenerator = yield getEventsAPI();
    const handler: any = response.success ? getEventsSuccess(response.data) : getEventsError();
    yield put(handler);
}

function* getEvent(action: IAction) {
    const response: ResponseGenerator = yield getEventAPI(action.payload);
    const handler: any = response.success ? getEventSuccess(response.data) : getEventError();
    yield put(handler);
}

function* addEvent(action: IAction) {
    const response: ResponseGenerator = yield addEventAPI(action.payload);
    const handler: any = response.success ? eventAddSuccess(response.data) : eventAddError();
    yield put(handler);
}

function* updateEvent(action: IAction) {    
    const response: ResponseGenerator = yield updateEventAPI(action.payload);
    const handler: any = response.success ? eventUpdateSuccess(response.data) : eventUpdateError();
    yield put(handler);
}

function* removeEvent(action: IAction) {
    const response: ResponseGenerator = yield removeEventAPI(action.payload);
    const handler: any = response.success ? eventRemoveSuccess(response.data) : eventRemoveError();
    yield put(handler);
}

export function* rootSaga() {
    const sagas = [eventWatcher()]; // Load all the sagas
    yield all(sagas);
}